import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '../react.module'
import '../stylesheets/application.css.scss'

const componentRequireContext = require.context('components_v1', true)
const ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
